import {fbauth, db} from '@/firebase/firebase.js'

const state = {
  user: null,
  userPhoto: null
}

const getters = {
  currentUser (state) {
    if (state.user !== null) {
      return state.user.id
    } else {
      return null
    }
  },
  emailAddress (state) {
    if (state.user !== null) {
      return state.user.email
    } else {
      return null
    }
  },
  emailVerified (state) {
    if (state.user !== null) {
      return state.user.emailVerified
    } else {
      return false
    }
  },
  displayName (state) {
    if (state.user !== null) {
      return state.user.name
    } else {
      return null
    }
  },
  user (state) {
    return state.user
  },
  isLoggedIn (state) {
    return state.user != null
  }
}

const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  setUserPhoto (state, payload) {
    state.userPhoto = payload
  },
  setUserName (state, payload) {
    state.user.name = payload
  }
}

const actions = {
  signUpUser ({commit}, payload, dispatch) {
    fbauth.createUserWithEmailAndPassword(payload.email, payload.password)
    .then(
      user => {
        db.ref('users/' + user.uid + '/info').set({
          userName: '',
          firstName: '',
          lastName: '',
          organization: '',
          avatarRef: '',
          emailAddress: user.email
        })
      })
    .catch(
      error => {
        console.error(error)
        commit('setAlert', error.code, {root: true})
      }
    )
  },
  updateAuthData ({commit, dispatch}, payload) {
    let newUser = null
    if (payload !== null) {
      newUser = {
        name: payload.displayName,
        email: payload.email,
        emailVerified: payload.emailVerified,
        id: payload.uid
      }
    }
    commit('setUser', newUser)
  },
  logInUser ({commit, dispatch}, payload) {
    fbauth.signInWithEmailAndPassword(payload.email, payload.password)
    .catch(
      error => {
        console.error(error)
        commit('setAlert', error.code, {root: true})
      }
    )
  },
  setDisplayName ({commit}, payload) {
    var user = fbauth.currentUser
    user.updateProfile({
      displayName: payload.userName
    }).then(function () {
      commit('setUserName', payload.userName)
    }).catch(function (error) {
      console.error(error)
    })
  },
  logOutUser ({commit}) {
    fbauth.signOut()
    .catch(function (error) {
      console.error(error)
    })
  },
  googleSignUp () {
    var provider = new fbauth.GoogleAuthProvider()
    fbauth.signInWithRedirect(provider).then(
      user => {
        db.ref('users/' + user.uid + '/info').set({
          userName: '',
          firstName: '',
          lastName: '',
          organization: '',
          avatarRef: '',
          emailAddress: user.email
        })
      })
  },
  sendVerificationEmail () {
    var user = fbauth.currentUser
      // var actionCodeSettings = {
      //   url: 'https://tellus.com/userinfo'
      // }
     // user.sendEmailVerification(actionCodeSettings).then(function () {
    user.sendEmailVerification().then(function () {

    }).catch(function (error) {
      console.error(error)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js